/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaveTeamResponse
 */
export interface LeaveTeamResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LeaveTeamResponse
     */
    success: boolean;
    /**
     * True if the team was disbanded because the captain (last member) left
     * @type {boolean}
     * @memberof LeaveTeamResponse
     */
    teamDisbanded: boolean;
}

/**
 * Check if a given object implements the LeaveTeamResponse interface.
 */
export function instanceOfLeaveTeamResponse(value: object): value is LeaveTeamResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('teamDisbanded' in value) || value['teamDisbanded'] === undefined) return false;
    return true;
}

export function LeaveTeamResponseFromJSON(json: any): LeaveTeamResponse {
    return LeaveTeamResponseFromJSONTyped(json, false);
}

export function LeaveTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaveTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'teamDisbanded': json['teamDisbanded'],
    };
}

export function LeaveTeamResponseToJSON(json: any): LeaveTeamResponse {
    return LeaveTeamResponseToJSONTyped(json, false);
}

export function LeaveTeamResponseToJSONTyped(value?: LeaveTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'teamDisbanded': value['teamDisbanded'],
    };
}

